import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

let msalInstance = null;

export const getMsalInstance = () => {
  if (msalInstance) {
    return msalInstance;
  }

  if (!msalConfig.auth?.clientId || !msalConfig.auth?.authority) {
    return null;
  }

  msalInstance = new PublicClientApplication(msalConfig);
  return msalInstance;
};
